import {useOpenUrl} from '@shm/shared'
import {useNavigate, useNavRoute} from '@shm/shared/utils/navigation'
import {SchemaBrowserPage} from '@shm/ui/schema/schema-browser'

/** Parse a reserved `/hm/schema/<cid>` URL back to a schema route (mirrors routeToHref). */
export function extractSchemaRouteFromPath(pathParts: string[]): {key: 'schema'; cid: string} | null {
  if (pathParts[0] !== 'hm' || pathParts[1] !== 'schema' || !pathParts[2]) return null
  return {key: 'schema', cid: pathParts[2]}
}

/** Full-page schema browser for the web app. */
export function WebSchemaPage() {
  const route = useNavRoute()
  const navigate = useNavigate()
  const openUrl = useOpenUrl()
  if (route.key !== 'schema') throw new Error(`WebSchemaPage: unsupported route ${route.key}`)
  return <SchemaBrowserPage cid={route.cid} docId={route.id} navigate={navigate} openUrl={openUrl} />
}
